import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePortalAuth } from "@/lib/portalAuth";
import { ErrorState } from "@/components/common/ErrorState";

export const PortalProtectedRoute = () => {
  const { usuario, errorSesion, reintentarSesion } = usePortalAuth();
  const location = useLocation();

  if (errorSesion) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--tc-surface)] px-5">
        <ErrorState
          testId="portal-session-error"
          mensaje="No pudimos verificar tu sesión. Revisá tu conexión e intentá de nuevo."
          onRetry={reintentarSesion}
        />
      </div>
    );
  }

  if (usuario === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--tc-surface)]">
        <Loader2 className="animate-spin text-[var(--tc-accent)]" size={28} />
      </div>
    );
  }

  if (usuario === false) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
